<template>
  <div :class="b()" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
// parseUrl
import { getUrlParams } from '@/utils/utils';
import init from '@/mixins/chart';
export default {
  name: 'maps',
  inject: ['contain'],
  mixins: [init],
  data() {
    return {
      bannerCount: 0,
      bannerCheck: '',
      zoomData: 1
    };
  },
  mounted() {
    this.map && (this.option.mapUrl = this.map.value);
  },
  watch: {
    mapUrl() {
      this.updateChart();
    },
    // dataChartLen () {
    //   this.setBanner();
    // },
    // playInterval () {
    //   this.setBanner();
    // },
    // autoPlay: {
    //   handler () {
    //     this.setBanner();
    //   },
    //   immediate: true
    // },
    width() {
      this.updateData();
    },
    height() {
      this.updateData();
    }
  },
  computed: {
    map() {
      const area = getUrlParams(decodeURI(location.search)).params.area;
      return this.contain.DIC.MAP.find(item => item.label === area);
    },
    mapUrl() {
      return this.option.mapUrl || {};
    },
    mapData() {
      return this.dataChart.map(item => {
        if (this.map) {
          item.type = this.map.value ? 'city' : 'province';
        } else {
          item.type = 'province';
        }
        return item;
      });
    },
    playInterval() {
      return this.option.playInterval || 3000;
    },
    autoPlay() {
      return this.option.autoPlay;
    },
    hasLink() {
      return this.option.hasLink;
    },
    // 图表类
    tooltip() {
      return Object.assign(
        (() =>
          this.formatter ? { formatter: name => this.formatter(name, this.dataChart) } : {})(),
        {
          backgroundColor: this.option.tipBackgroundColor,
          textStyle: {
            fontSize: this.setPx(this.option.tipFontSize),
            color: this.option.tipColor
          }
        }
      );
    },
    visualMap() {
      return Object.assign(
        {
          show: this.option.visualMap,
          type: this.option.VMType,
          orient: this.option.VMOrient,
          itemWidth: this.option.VMItemWidth,
          itemHeight: this.option.VMItemHeight,
          left: this.option.VMSplitX + '%',
          bottom: this.option.VMSplitY + '%',
          min: this.dataChart.length > 1 ? Math.min(...this.dataChart.map(item => item.value)) : 0,
          max: this.dataChart.length ? Math.max(...this.dataChart.map(item => item.value)) : 400,
          showLabel: true,
          calculable: this.option.VMCalculable,
          text: this.option.VMTest.split('|'),
          textStyle: {
            color: this.option.VMTestColor,
            fontSize: this.option.VMTestSize
          }
        },
        (() => {
          if (this.option.VMType === 'piecewise') {
            return { pieces: this.option.VMInRange };
          }
          return { inRange: { color: this.option.VMInRange.map(item => item.color) } };
        })()
      );
    },
    geo() {
      return {
        map: 'HK',
        roam: this.option.canRoam,
        zoom: this.option.geoZoom,
        label: {
          normal: {
            show: this.option.showLabel,
            textStyle: {
              color: this.option.geoColor,
              fontSize: this.option.geoFontSize
            }
          },
          emphasis: {
            show: this.option.showLabel,
            textStyle: {
              color: this.option.geoEmpColor,
              fontSize: this.option.geoFontSize
            }
          }
        },
        itemStyle: {
          normal: {
            borderWidth: this.option.geoBorderWidth,
            borderColor: this.option.geoBorderColor,
            areaColor: this.option.geoAreaColor
          },
          emphasis: {
            borderWidth: this.option.geoBorderWidth,
            borderColor: this.option.geoEmpBorderColor,
            areaColor: this.option.geoEmpAreaColor
          }
        }
      };
    }
  },
  methods: {
    updateChart() {
      this.$axios(this.mapUrl).then(res => {
        const data = res.data;
        const optionData = this.deepClone(data);
        window.echarts.registerMap('HK', optionData);
        const option = {
          tooltip: this.tooltip,
          visualMap: this.visualMap,
          geo: this.geo,
          series: [
            {
              name: '确诊病例',
              type: 'map',
              geoIndex: 0,
              data: this.mapData
            }
          ]
        };
        this.myChart.resize();
        this.myChart.setOption(option, true);
        this.chartClick();
      });
    },
    bindClick() {
      this.myChart.on('click', e => {
        this.progressClick({ name: e.name, value: e.value });
        // if (this.hasLink) {
        //   if (e.marker) {
        //     const map = this.contain.DIC.MAP.find(item => item.label === e.name);
        //     if (map) {
        //       let { linkHref = '#', linkTarget } = this.option;
        //       linkHref = parseUrl(linkHref, e.data);
        //       linkTarget === '_blank' ? window.open(linkHref) : (window.location.href = linkHref);
        //     } else {
        //       this.$message('无此区域地图显示!');
        //     }
        //   }
        // }
      });
    }
  }
};
</script>
